import { ReactNode } from 'react';
import useContentProtection from '@/hooks/useContentProtection';

interface ContentProtectionWrapperProps {
  children: ReactNode;
}

/**
 * Lightweight wrapper that applies content protection
 * No visual effects, no performance impact
 */
const ContentProtectionWrapper = ({ children }: ContentProtectionWrapperProps) => {
  useContentProtection();
  return <>{children}</>;
};

export default ContentProtectionWrapper;
